import { Tag } from '@varo/graphql-schema-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import IconAvatar from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import { Tag as VXLTag } from 'shared/components/vxl/Tag/Tag';
import { propsFromTag } from 'shared/components/vxl/Tag/Tag.helpers';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import TitleXLText from 'shared/components/vxl/typography/primary/title/TitleXLText';
import theme from 'shared/styles/theme';
import { Maybe } from 'shared/utils/types';

interface TitleLockUpProps {
  logoUrl?: Maybe<string>;
  merchant: string;
  offerRate: string;
  tag?: Maybe<Tag> | undefined;
  validityText?: string;
}
const NUMBER_OF_LINES = 2;

const TitleLockUp = ({
  logoUrl,
  merchant,
  offerRate,
  tag,
  validityText,
}: TitleLockUpProps) => {
  return (
    <View style={styles.container}>
      <TitleSmText style={styles.merchantName} numberOfLines={NUMBER_OF_LINES}>
        {merchant}
      </TitleSmText>

      <TitleXLText style={styles.cashbackRate} numberOfLines={NUMBER_OF_LINES}>
        {offerRate}
      </TitleXLText>

      <View style={styles.tagContainer}>
        {tag && propsFromTag(tag) ? <VXLTag {...propsFromTag(tag)!} /> : null}
        {validityText ? (
          <BodyXSText style={styles.validityText}>{validityText}</BodyXSText>
        ) : null}
      </View>

      <View style={styles.logoContainer}>
        <IconAvatar
          variant="LG"
          backgroundColor={theme.color.expressive.orchid}
          iconKey={logoUrl ? undefined : 'STORE'}
          defaultPlaceholderIcon="STORE"
          imageSource={logoUrl ? { uri: logoUrl } : undefined}
          iconAccessibilityLabel={`${merchant} logo`}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cashbackRate: {
    color: theme.color.text.primary,
    marginRight: 80,
    marginTop: theme.spacing.s,
  },
  container: {
    backgroundColor: theme.color.background.primary,
    overflow: 'hidden',
    paddingBottom: theme.spacing.l,
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.l,
    position: 'relative',
  },
  logoContainer: {
    elevation: 2,
    position: 'absolute',
    right: theme.spacing.m,
    shadowColor: theme.color.text.primary,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    top: theme.spacing.l,
  },
  merchantName: {
    color: theme.color.text.primary,
    marginRight: 80,
  },
  tagContainer: {
    alignItems: 'center',
    alignSelf: 'flex-start',
    flexDirection: 'row',
    gap: theme.spacing.s,
    marginRight: 80,
    marginTop: theme.spacing.s,
  },
  validityText: {
    color: theme.color.text.primary,
  },
});

export default TitleLockUp;
